module.exports = __webpack_public_path__ + "img/four.6fbd2af3.png";